import i18next from 'i18next';

i18next.addResources('en', 'MaturationYearOfDistillation', {
  yearsOfDestillation: 'YEARS OF DISTILLATION'
});
